module.exports = __webpack_public_path__ + "img/item4.250ecf27.png";